/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useState, useEffect } from "react";
import { Avatar_09, Avatar_10, Avatar_16 } from "../../Routes/ImagePath";
import { Link } from "react-router-dom";

import { useTranslation } from "react-i18next";

import AuthUser from "../AuthUser";

import { toast, ToastContainer } from "react-toastify";

import Spinner from "../Spinner";

const PesquisarColaboradorAdvancedModal = ({
  onSubmissionSuccess,
  utilizadores,
}) => {
  const { t } = useTranslation();

  // eslint-disable-next-line no-unused-vars
  const {
    http,
    url_root,
    user,
    user_permissoes,
    verificarPermissao,
    getMissao,
  } = AuthUser();

  // eslint-disable-next-line no-unused-vars
  const [loading, setLoading] = useState(false);

  const [name, setName] = useState("");
  const [matricula, setMatricula] = useState("");
  const [cargo_id, setCargoID] = useState("-1");
  const [departamento_id, setDepartamentoID] = useState("-1");
  const [local_id, setLocalID] = useState("-1");
  const [area_id, setAreaID] = useState("-1");
  const [categoria_id, setCategoriaID] = useState("-1");
  const [missao_id, setMissaoID] = useState("-1");
  const [curso_id, setCursoID] = useState("-1");
  const [genero, setGenero] = useState("-1");
  const [estado, setEstado] = useState("-1");

  const [tipo_contrato, setTipoContrato] = useState("-1");

  const [admissao, setAdmissao] = useState("");
  const [admissao2, setAdmissao2] = useState("");

  const [expatriado, setExpatriado] = useState("-1");

  const [missoes, setMissoes] = useState([]);
  const [locais, setLocais] = useState([]);
  const [cursos, setCursos] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [areas, setAreas] = useState([]);
  const [departamentos, setDepartamentos] = useState([]);
  const [cargos, setCargos] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);

  const triggerCloseButtonClick = (buttonId) => {
    const closeButton = document.getElementById(buttonId);
    if (closeButton) {
      closeButton.dispatchEvent(new Event("click"));
    }
  };

  const handleSelectExpatriadoChange = (valor) => {
    setExpatriado(valor);
  };

  useEffect(() => {
    getCargosDepartamentosCompanyCategoryArea();
  }, []);

  const getCargosDepartamentosCompanyCategoryArea = async () => {

    setLoading(true);
    
    try {
      console.log(
        "Calling cargos, departamentos, company, categoria, area, local"
      );
      const res = await http.get(
        "/cargos-departamentos-company-categoria-area"
      );

      setCargos(res?.data?.cargos);
      setDepartamentos(res?.data?.departamentos);
      setMissoes(res?.data?.missoes);
      setCursos(res?.data?.cursos);

      setLoading(false);

    } catch (error) {
      //toast.error("Ocorreu um erro ao carregar os projectos.");
      setLoading(false);
    }
  };

  const searchUtilizador = async () => {
    setLoading(true);

    const formData = new FormData();

    formData.append("termo", name); //search if contains in name, telefone, seg_social, nif, matricula, endereço, nivel_academico
    formData.append("cargo_id", String(cargo_id)); //ignore if -1 or null or ""
    formData.append("departamento_id", String(departamento_id)); //ignore if -1 or null or ""
    formData.append("missao_id", String(missao_id)); //ignore if -1 or null or ""
    formData.append("categoria_id", String(categoria_id)); //ignore if -1 or null or ""
    formData.append("area_id", String(area_id)); //ignore if -1 or null or ""
    formData.append("local_id", String(local_id)); //ignore if -1 or null or ""

    formData.append("admissao1", String(admissao)); //search employess joining date ( admissao ) between admissao1 and admissao2 ( ignore if null )
    formData.append("admissao2", String(admissao2)); //search employess joining date ( admissao ) between admissao1 and admissao2 ( ignore if null )
    formData.append("expatriado", String(expatriado)); //ignore if -1 or null or ""
    formData.append("genero", String(genero)); //ignore if -1 or null or ""
    formData.append("curso_id", String(curso_id)); //ignore if -1 or null or "" ( search if user is related to this course in table certificado) formando_id = user.id

    formData.append("estado", estado); //ignore if -1 or null or ""
    formData.append("tipo_contrato", tipo_contrato); //ignore if -1 or null or ""
    formData.append("matricula", matricula); //if matricula contains this value

    const response = await http.post("/utilizador/pesquisar-avanacada", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    setFilteredUsers(response?.data?.colaboradores || []);

    setLoading(false);
  };

  const renderOptionCargos = (cargos) => {
    return cargos?.map((cargo) => (
      <React.Fragment key={cargo.id}>
        <option value={cargo.id}>{cargo.designacao}</option>
      </React.Fragment>
    ));
  };

  const renderOptionDepartamentos = (departamentos) => {
    return departamentos?.map((departamento) => (
      <React.Fragment key={departamento.id}>
        <option value={departamento.id}>{departamento.designacao}</option>
      </React.Fragment>
    ));
  };

  const renderOptionMissoes = (missoes) => {
    return missoes?.map((missao) => (
      <React.Fragment key={missao.id}>
        <option value={missao.id}>
          ({missao?.sigla}){" - "}
          {missao.designacao}
        </option>
      </React.Fragment>
    ));
  };

  const renderOptionCursos = (cursos) => {
    return cursos?.map((curso) => (
      <React.Fragment key={curso.id}>
        <option value={curso.id}>{curso.designacao}</option>
      </React.Fragment>
    ));
  };

  const handleUserSelect = (selectedUser) => {
    // Here you can add the selected user to your project team or perform any other action
    console.log("Selected user:", selectedUser);

    if (selectedUser == null) {
      setFilteredUsers([]);
    } else {
      retornarColaborador(selectedUser?.id);
    }
  };

  const retornarColaborador = (user_id) => {

    onSubmissionSuccess(user_id);

    triggerCloseButtonClick("closeButton5");
  };

  return (
    <div>
      <div
        id="find_colaborador"
        className="modal custom-modal fade modal-lg"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">
                {loading ? <i className="fa fa-spinner fa-spin me-2"></i>:<i onClick={() => getCargosDepartamentosCompanyCategoryArea()} className="fa fa-recycle"></i>}{" "}Pesquisar Colaborador Filtro Avançado
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                id="closeButton5"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              {/* form start */}

              <hr></hr>

              <div className="row">
                <div className="col-xl-12 mb-3">
                  {loading && (
                    <div className="alert alert-primary text-center my-3">
                      <i className="fa fa-spinner fa-spin me-2"></i> Loading...
                    </div>
                  )}
                </div>
                <div className="col-sm-9">
                  <div className="input-block mb-3 mb-3 form-focus focused">
                    <label className="focus-label">Termo de pesquisa</label>
                    <input
                      className="form-control"
                      type="text"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                    />
                  </div>
                </div>

                <div className="col-sm-3">
                  <div className="input-block mb-3 mb-3 form-focus focused">
                    <label className="focus-label">Genero</label>
                    <select
                      className="form-control select"
                      value={genero}
                      onChange={(e) => setGenero(String(e.target.value))}
                    >
                      <option value="-1"> - </option>
                      <option value="1">Femninino</option>
                      <option value="2">Masculino</option>
                    </select>
                  </div>
                </div>

                <div className="col-sm-3">
                  <div className="input-block mb-3 form-focus focused">
                    <label className="focus-label">Data de admissão de </label>
                    <input
                      className="form-control"
                      type="date"
                      value={String(admissao)}
                      onChange={(e) => setAdmissao(e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-sm-3">
                  <div className="input-block mb-3 form-focus focused">
                    <label className="focus-label">Data de admissão ate</label>
                    <input
                      className="form-control"
                      type="date"
                      value={String(admissao2)}
                      onChange={(e) => setAdmissao2(e.target.value)}
                    />
                  </div>
                </div>

                <div className="col-sm-6">
                  <div className="input-block mb-3 mb-3 form-focus focused">
                    <label className="focus-label">Cargo</label>
                    <select
                      onChange={(e) => setCargoID(e.target.value)}
                      value={cargo_id}
                      className="form-control select"
                    >
                      <option key={0} value={-1}>
                        -
                      </option>
                      {renderOptionCargos(cargos)}
                    </select>
                  </div>
                </div>

                <div className="col-sm-9">
                  <div className="input-block mb-3 mb-3 form-focus focused">
                    <label className="focus-label">Departmento</label>
                    <select
                      onChange={(e) => setDepartamentoID(e.target.value)}
                      value={departamento_id}
                      className="form-control select"
                    >
                      <option key={0} value={-1}>
                        -
                      </option>
                      {renderOptionDepartamentos(departamentos)}
                    </select>
                  </div>
                </div>

                <div className="col-sm-3">
                  <div className="input-block mb-3 mb-3 form-focus focused">
                    <label className="focus-label">Expatriado ?</label>
                    <select
                      className="form-control select"
                      onChange={(e) =>
                        handleSelectExpatriadoChange(e.target.value)
                      }
                      value={expatriado}
                    >
                      <option value="-1">-</option>
                      <option value="1">Não</option>
                      <option value="2">Sim</option>
                    </select>
                  </div>
                </div>

                <div className="col-sm-6">
                  <div className="input-block mb-3 mb-3 form-focus focused">
                    <label className="focus-label">Localização</label>
                    <select
                      onChange={(e) => setMissaoID(String(e.target.value))}
                      value={missao_id}
                      className="form-control select"
                    >
                      <option key={0} value={-1}>
                        -
                      </option>
                      {renderOptionMissoes(missoes)}
                    </select>
                  </div>
                </div>

                <div className="col-sm-6">
                  <div className="input-block mb-3 mb-3 form-focus focused">
                    <label className="focus-label">Estado</label>
                    <select
                      className="form-control select"
                      value={estado}
                      onChange={(e) => setEstado(String(e.target.value))}
                    >
                      <option value="-1"> - </option>
                      <option value="1">Activo</option>
                      <option value="0">Desativado</option>
                    </select>
                  </div>
                </div>

                <div className="col-sm-12">
                  <div className="input-block mb-3 mb-3 form-focus focused">
                    <label className="focus-label">Certificações</label>
                    <select
                      onChange={(e) => setCursoID(e.target.value)}
                      value={curso_id}
                      className="form-control select"
                    >
                      <option key={0} value={-1}>
                        -
                      </option>
                      {renderOptionCursos(cursos)}
                    </select>
                  </div>
                </div>

                <div className="submit-section mb-5">
                  <a
                    className="btn btn-primary submit-btn"
                    onClick={() => searchUtilizador()}
                  >
                    {loading ? "Loading" : "Search"}
                  </a>
                </div>
              </div>

              {/* form end */}

              <hr></hr>
              <div>
                {
                  filteredUsers.length > 0 && (
                    <ul className="chat-user-list">
                      {filteredUsers.map((user) => (
                        <li key={user.id}>
                          <span onClick={() => handleUserSelect(user, 2)}>
                            <div className="chat-block d-flex">
                              <span className="avatar">
                                <img
                                  src={
                                    url_root + "/storage/" + user?.fotografia
                                  }
                                  alt={user?.name}
                                  title={user?.name}
                                />
                              </span>
                              <div className="media-body align-self-center text-nowrap">
                                <div className="user-name">{user?.name}</div>
                                <span className="designation">
                                  {user?.cargo?.designacao}
                                </span>
                              </div>
                            </div>
                          </span>
                        </li>
                      ))}
                    </ul>
                  
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <ToastContainer />
    </div>
  );
};

export default PesquisarColaboradorAdvancedModal;
